import { apiClient } from '@/lib/api-client';

/**
 * Platform-admin API — /api/v1/admin/*
 *
 * All endpoints require the caller to be a platform admin. The SPA hides
 * the location switcher (and the whole /settings/platform-admin page)
 * from non-admins, but the enforcement lives on the backend via
 * `require_platform_admin`.
 */

export interface AdminLocation {
  id: string;
  slug: string;
  name: string;
  status: string;
  timezone: string;
  created_at: string;
  operator_count: number;
  mailbox_count: number;
  campaign_count: number;
  lead_count: number;
}

export interface AdminOperator {
  id: string;
  email: string;
  name: string | null;
  role: string;
  is_platform_admin: boolean;
  email_verified_at: string | null;
  last_login_at: string | null;
  created_at: string;
  location_count: number;
}

export interface SwitchLocationResult {
  switched_to: string;
  location_name: string;
  is_platform_admin: boolean;
}

export const adminApi = {
  listLocations: () =>
    apiClient.get<AdminLocation[]>('/api/v1/admin/locations'),
  switchLocation: (id: string) =>
    apiClient.post<SwitchLocationResult>(`/api/v1/admin/switch/${id}`),
  listOperators: () =>
    apiClient.get<AdminOperator[]>('/api/v1/admin/operators'),
  setPlatformAdmin: (operatorId: string, isPlatformAdmin: boolean) =>
    apiClient.post<AdminOperator>(
      `/api/v1/admin/operators/${operatorId}/promote`,
      { is_platform_admin: isPlatformAdmin },
    ),
};
